export function hostnameFromURL(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.protocol + '//' + a.hostname;
}
